import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-national-moves',
  templateUrl: './national-moves.component.html',
  styleUrls: ['./national-moves.component.scss']
})
export class NationalMovesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
